<p>studiewijzerlinkjes-vaksectie-platform-details-table-row-component works!</p>
